module.exports = __webpack_public_path__ + "static/media/community-file-black.41f89588.svg";